export const toIndianCurrencyFormat = (amount, isShowCurrency = true) => {
    // Convert the amount to string
    let amountStr = amount.toString();

    // Split the amount into integer and decimal parts
    let [integerPart, decimalPart] = amountStr.split('.');

    // Apply Indian number system formatting to the integer part
    let lastThree = integerPart.slice(-3);
    let otherNumbers = integerPart.slice(0, -3);
    if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
    }
    let formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

    // Combine the formatted integer part with the decimal part (if any)
    let formattedAmount = decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;

    // Add rupee symbol if isShowCurrency is true
    if (isShowCurrency) {
        formattedAmount = '₹' + formattedAmount;
    }

    return formattedAmount;
}

export const roundAmount2Dig = (amt, isPad = false, useIndianFormat = false) => {
    if (typeof amt === 'string') {
        amt = parseFloat(amt);
    }

    let roundoffamt = Math.round(amt * 100) / 100;

    if (isPad) {
        roundoffamt = roundoffamt.toFixed(2);
    }

    if (useIndianFormat) {
        // Convert to string if it's not already
        let numStr = roundoffamt.toString();
        
        // Split the string into parts before and after decimal point
        let parts = numStr.split('.');
        let integerPart = parts[0];
        let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

        // Add commas for the integer part
        let lastThree = integerPart.substring(integerPart.length - 3);
        let otherNumbers = integerPart.substring(0, integerPart.length - 3);
        if (otherNumbers !== '') {
            lastThree = ',' + lastThree;
        }
        let formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

        // Combine integer and decimal parts
        return formattedInteger + decimalPart;
    }

    return roundoffamt;
}